// // // export const BASE_URL = "http://187.124.34.134:5000/api";


export const BASE_URL = "https://ansaryinventrastore.cloud/api";




// export const BASE_URL = "http://localhost:5196/api";
